import React from "react";
import styled from "styled-components";
import { FiPlus } from "react-icons/fi";
// import ExportButton from "./ExportButton";

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  position: relative;
`;

const WelcomeMessage = styled.div`
  h1 {
    font-size: 1.8rem;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 0.5rem;
  }

  p {
    color: #666;
    font-size: 1rem;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  background: ${props => props.$primary ? '#007aff' : '#fff'};
  color: ${props => props.$primary ? '#fff' : '#007aff'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: 0.5s;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    
    &:before {
      left: 100%;
    }
  }

  svg {
    font-size: 1.2rem;
  }
`;

const HeaderSection = ({ userPlan, onNewRequest, reallocateLeads, dashboardRef }) => {
  return (
    <HeaderContainer>
      <WelcomeMessage>
        <h1>Bem-vindo de volta!</h1>
        <p>Aqui está o resumo das suas realocações</p>
      </WelcomeMessage>
      <ActionButtons>
        <Button $primary onClick={onNewRequest}>
          <FiPlus /> Nova Solicitação
        </Button>
        {/* {userPlan !== 'Free' && (
          <ExportButton data={reallocateLeads} dashboardRef={dashboardRef} />
        )} */}
      </ActionButtons>
    </HeaderContainer>
  );
};

export default HeaderSection;